import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {MenuInnerWithSub} from './MenuInnerWithSub'

export function DuaMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/dua/'

  const menuItems = [{permission: null, title: t('MENU.HOME'), to: `${base}home`}]

  return (
    <>
      {menuItems.map(
        ({permission, title, to}) =>
          (!permission || hasPermission(permission)) && <MenuItem key={to} title={title} to={to} />
      )}

      {(hasPermission('kankor-term-list') ||
        hasPermission('kankor-term-create') ||
        hasPermission('kankor-term-report') ||
        hasPermission('kankor-application-attendance')) && (
        <MenuInnerWithSub
          title={t('MENU.KANKOR')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
          fontIcon=''
        >
          {hasPermission('kankor-term-list') && (
            <MenuItem
              to='/dua/kankor-terms'
              fontIcon='fas fa-hourglass-half mx-2'
              title={t('MENU.KANKOR_TERMS')}
            />
          )}
          {hasPermission('kankor-application-list') && (
            <MenuItem
              to='/dua/kankor-apps'
              fontIcon='fas fa-file-signature mx-2'
              title={t('MENU.KANKOR_APPLICATIONS')}
            />
          )}
          {hasPermission('kankor-application-archive-list') && (
            <MenuItem
              to='/dua/kankor-archive-apps'
              fontIcon='fas fa-archive mx-2'
              title={t('MENU.ARCHIVE_KANKOR_APPLICATIONS')}
            />
          )}
          {hasPermission('kankor-application-attendance') && (
            <MenuItem
              to='/dua/kankor-attendance'
              fontIcon='fas fa-user-check mx-2'
              title={t('LABEL.ATTENDANCE')}
            />
          )}
          {hasPermission('online-application-list') && (
            <MenuItem
              to='/dua/online-applications'
              fontIcon='fas fa-file-alt mx-2'
              title={t('MENU.ONLINE_APPLICATIONS')}
            />
          )}
          {hasPermission('kankor-term-report') && (
            <MenuInnerWithSub
              title={t('MENU.REPORT')}
              to=''
              fontIcon='fas fa-list mx-2'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('lecturer-list') && (
                <MenuItem
                  to='dua/term-report'
                  fontIcon='fas fa-list-check mx-2'
                  title={t('LABEL.KANKOR_APPLICATION') + ' ' + t('MENU.REPORT')}
                />
              )}
              {hasPermission('lecturer-attendance-create') && (
                <MenuItem
                  to='dua/succeed-app-report'
                  fontIcon='fas fa-list-check mx-2'
                  title={t('MENU.SUCCEED_APPLICATIONS') + ' ' + t('MENU.REPORT')}
                />
              )}
            </MenuInnerWithSub>
          )}
        </MenuInnerWithSub>
      )}

      {(hasPermission('term-list') || hasPermission('kankor-term-create')) && (
        <MenuInnerWithSub
          title={t('MENU.ACADEMICS')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
          fontIcon=''
        >
          {hasPermission('term-list') && (
            <MenuItem
              to='/dua/terms'
              fontIcon='fas fa-solid fa-clock mx-2'
              title={t('MENU.TERMS')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {(hasPermission('students-list') ||
        hasPermission('students-archive-list') ||
        hasPermission('student-attendance-report') ||
        hasPermission('student-score-report')) && (
        <MenuInnerWithSub
          title={t('MENU.STUDENTS')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
          fontIcon=''
        >
          {hasPermission('students-list') && (
            <MenuItem
              to='/dua/students'
              fontIcon='fas fa-user-graduate mx-2'
              title={t('STUDENTS.STUDENT_LIST')}
            />
          )}

          {hasPermission('students-archive-list') && (
            <MenuItem
              to='/dua/archive-students'
              fontIcon='fas fa-archive mx-2'
              title={t('MENU.ARCHIVE_STUDENT')}
            />
          )}

          <MenuInnerWithSub
            title={t('MENU.REPORT')}
            to={''}
            fontIcon='fas fa-list-check mx-2'
            hasArrow={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {hasPermission('student-attendance-report') && (
              <MenuItem
                to='/dua/student-attendance-report'
                fontIcon='fas fa-calendar-check mx-2'
                title={t('MENU.ATTENDANCE_REPORT')}
              />
            )}

            {hasPermission('student-score-report') && (
              <MenuItem
                to='/dua/student-score-report'
                fontIcon='fa fa-clipboard-list mx-2'
                title={t('MENU.SCORE_REPORT')}
              />
            )}

            {hasPermission('students-credit-report') && (
              <MenuItem
                to='/dua/student-credit-report'
                fontIcon='fa fa-clipboard-list mx-2'
                title={t('MENU.CREDIT_REPORT')}
              />
            )}

            {hasPermission('students-semester-book') && (
              <MenuItem
                to='/dua/student-semester-book'
                fontIcon='fas fa-book-open mx-2'
                title={t('MENU.SEMESTER_BOOK')}
              />
            )}

            {hasPermission('students-semester-upgrade') && (
              <MenuItem
                to='/dua/student-semester-upgrade'
                fontIcon='fas fa-list-check mx-2'
                title={t('MENU.UPGRADE_SEMESTER')}
              />
            )}

            <MenuItem
              to='/dua/student-graduation-book'
              fontIcon='fas fa-book-open mx-2'
              title={t('MENU.GRADUATION_BOOK')}
            />
          </MenuInnerWithSub>
        </MenuInnerWithSub>
      )}

      {(hasPermission('position-list') ||
        hasPermission('lecturer-list') ||
        hasPermission('employee-list')) && (
        <MenuInnerWithSub
          title={t('MENU.HR')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
          fontIcon=''
        >
          {hasPermission('lecturer-list') && (
            <MenuInnerWithSub
              title={t('MENU.LECTURERS')}
              to='/dua/lecturers'
              fontIcon='fas fa-user-tie mx-2'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('lecturer-list') && (
                <MenuItem
                  to='dua/lecturers'
                  fontIcon='fas fa-user-tie mx-2'
                  title={t('MENU.LECTURERS')}
                />
              )}
              {hasPermission('lecturer-attendance-create') && (
                <MenuItem
                  to='dua/lecturer-attendance-create'
                  fontIcon='fas fa-calendar-check mx-2'
                  title={t('MENU.ATTENDANCE')}
                />
              )}
              {hasPermission('lecturer-attendance-report') && (
                <MenuItem
                  to='dua/lecturer-attendance-report'
                  fontIcon='fas fa-file-alt mx-2'
                  title={t('MENU.ATTENDANCE_REPORT')}
                />
              )}
              {hasPermission('lecturer-attendance-payroll') && (
                <MenuItem
                  to='dua/lecturer-attendance-payroll'
                  fontIcon='fas fa-file-invoice-dollar mx-2'
                  title={t('MENU.ATTENDANCE_PAYROLL')}
                />
              )}
            </MenuInnerWithSub>
          )}

          {hasPermission('employee-list') && (
            <MenuInnerWithSub
              title={t('MENU.EMPLOYEE')}
              to='/dua/employees'
              fontIcon='fas fa-user-tie mx-2'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('employee-list') && (
                <MenuItem
                  to='dua/employees'
                  fontIcon='fas fa-user-tie mx-2'
                  title={t('MENU.EMPLOYEE')}
                />
              )}
              {hasPermission('employee-attendance-create') && (
                <MenuItem
                  to='dua/employee-attendance-create'
                  fontIcon='fas fa-calendar-check mx-2'
                  title={t('MENU.ATTENDANCE')}
                />
              )}
              {hasPermission('employee-attendance-view') && (
                <MenuItem
                  to='dua/employee-attendance-view'
                  fontIcon='fas fa-calendar mx-2'
                  title={t('MENU.ATTENDANCE_VIEW')}
                />
              )}
              {hasPermission('employee-leave-list') && (
                <MenuItem
                  to='dua/employee-leaves'
                  fontIcon='fas fa-calendar-day mx-2'
                  title={t('MENU.LEAVE')}
                />
              )}
              {hasPermission('employee-attendance-report') && (
                <MenuItem
                  to='dua/employee-attendance-report'
                  fontIcon='fas fa-file-alt mx-2'
                  title={t('MENU.ATTENDANCE_REPORT')}
                />
              )}
              {hasPermission('employee-attendance-payroll') && (
                <MenuItem
                  to='dua/employee-attendance-payroll'
                  fontIcon='fas fa-file-invoice-dollar mx-2'
                  title={t('MENU.ATTENDANCE_PAYROLL')}
                />
              )}
            </MenuInnerWithSub>
          )}

          {hasPermission('organization-unit-list') && (
            <MenuItem
              to='dua/organization-list'
              fontIcon='fas fa-sitemap mx-2'
              title={t('MENU.ORGANIZATION_UNITS')}
            />
          )}

          {hasPermission('position-list') && (
            <MenuItem
              to='/dua/positions'
              fontIcon='fas fa-clipboard-list mx-2'
              title={t('MENU.POSITION')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {(hasPermission('kankor-app-fee-list') || hasPermission('kankor-term-create')) && (
        <MenuInnerWithSub
          title={t('MENU.FINANCE')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
          fontIcon=''
        >
          {/* {hasPermission('kankor-app-fee-list') && (
            <MenuItem
              to='/dua/kankor-app-fee'
              fontIcon='fas fa-usd mx-2'
              title={t('MENU.KANKOR_FEES')}
            />
          )}
          {hasPermission('kankor-app-fee-list') && (
            <MenuItem
              to='/dua/kankor-app-refund-fee'
              fontIcon='fas fa-usd mx-2'
              title={t('MENU.KANKOR_REFUND_FEES')}
            />
          )} */}

          {hasPermission('student-invoice-list') && (
            <MenuItem
              to='/dua/student-invoices-list'
              fontIcon='fas fa-usd mx-2'
              title={t('MENU.STUDENT_INVOICE')}
            />
          )}

          {hasPermission('student-invoice-print-exam-card') && (
            <MenuItem
              to='/dua/student-exam-card'
              fontIcon='fas fa-id-card mx-2'
              title={t('MENU.EXAM_CARD')}
            />
          )}

          {hasPermission('finance-companies-list') && (
            <MenuItem
              to='/dua/companies'
              fontIcon='fas fa-building mx-2'
              title={t('MENU.COMPANIES')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {hasPermission('user-list') && (
        <MenuInnerWithSub
          title={t('MENU.USERS')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={true}
        >
          {hasPermission('user-list') && (
            <MenuItem
              to='/dua/staff-users'
              fontIcon='fa fa-users mx-2'
              title={t('MENU.STAFF_USERS')}
            />
          )}
          {hasPermission('user-list') && (
            <MenuItem
              to='/dua/lecturer-users'
              fontIcon='fa fa-users mx-2'
              title={t('MENU.LECTURER_USERS')}
            />
          )}
          {hasPermission('user-list') && (
            <MenuItem
              to='/dua/student-users'
              fontIcon='fa fa-users mx-2'
              title={t('MENU.STUDENT_USERS')}
            />
          )}
        </MenuInnerWithSub>
      )}
    </>
  )
}
